PJQ.views.projects.ProjectInviteListDataTable = PJQ.views.dataTables.DataTable.extend({
	defaults: {
		subTemplates: {
			header: new PJQ.templating.Template(PJQ.constants.modules.PROJECTLIST, 'Data-Table-Header-Project-Invites-List')
		},
		deferRender: true,
		language: {
			zeroRecords: "You haven't been sent any project invites yet"
		},
		onGoToProject: _.noop,
		onUploadRevision: _.noop,
		onChangeReport: _.noop,
		onArchive: _.noop,
		onDelete: _.noop,
		onRecycle: _.noop,
		onRestore: _.noop,
		settings: null
	},
	events: {
		'keyup .datatable-search': 'search',
		'click .project-invites-list-clear-filters': 'clearFilters',
		'change .project-invites-list-favorite-filter': 'favoriteFilterChanged'
	},
	beforeDataTableRender: function () {
		this.options.scrollRows = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DATA_TABLE_FIXED_HEADER);
	},
	afterDataTableRender: function () {
		this.$('input.project-invites-list-favorite-filter').prop('checked', this.options.settings.getFavoriteFilter());
	},
	getFilterData: function () {
		let favoriteFilter = this.options.settings.getFavoriteFilter();
		if (!favoriteFilter) {
			return this.options.collection.models;
		}

		return _.filter(this.options.collection.models, function (row) {
			if (favoriteFilter)
				return row.attributes.isFavorite;
		}, this);
	},
	afterSearch: function () {
		//this.$('.project-selector-clear-filters').prop('disabled', _.size(this.$('input.datatable-search').val()) === 0 && _.size(this.projectStatusFilter) === 0);
	},
	favoriteFilterChanged: function () {
		this.options.settings.setFavoriteFilter(this.$('input.project-invites-list-favorite-filter').prop('checked'));
		this.filter();
	},
	clearFilters: function () {
		this.$('input.datatable-search').val('');
		this.$('input.project-invites-list-favorite-filter').prop('checked', false);
		this.options.settings.setFavoriteFilter(false);

		this.filter();
	}
});

PJQ.views.projects.ProjectInvitesList = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTLIST, 'Project-Invites-List'),
		language: {
			zeroRecords: "You haven't been sent any project invites yet"
		}
	},
	events: {
		'click .btn-join-directory': 'joinDirectory',
		'click .btn-favorite-project': 'favoriteProject',
		'click .btn-go-to-project': 'goToProjectClicked',
		'click .btn-delete-project-invite': 'deleteProjectInviteClicked'
	},
	beforeFirstRender: function () {
		if (this.collection == null) {
			this.collection = new PJQ.collections.projects.Projects([], {
				isProjectInvites: true,
				isSimple: true
			});
		}

		this.collection.fetch({
			success: _.bind(function () {
				this.render();
			}, this)
		});
	},
	renderData: function () {
		return {
			collection: this.collection
		};
	},
	afterRender: function () {
		let columns;
		if (!this.collection.isFetched) {
			new PJQ.Loader(this.$('.project-invites-list'));
		}
		else {
			if (PJQ.app.session.get('portalId') === 4) {
				columns = [
					{
						"columnData": 'isFavorite',
						"title": '',
						"render": function (data, type, row) {
							if (type === 'sort' || type === 'type')
								return row.attributes.isFavorite;
							return row.attributes.isFavorite ? '<button type="button" class="btn btn-transparent-light btn-favorite-project ml-2" title="Unmark Favorite" data-project-id="' + row.attributes.projectId + '"><i class="fas fa-star text-gold"></i></button>' : '<button type="button" class="btn btn-transparent-light btn-favorite-project ml-2" title="Mark Favorite" data-project-id="' + row.attributes.projectId + '"><i class="far fa-star text-muted"></i></button>';
						},
						"orderable": false,
						"searchable": false,
						"className": "text-center",
						"width": "60px",
						"visible": true
					},
					{
						"data": "attributes.projectName",
						"title": "Name",
					},
					{
						"data": "attributes.companyName",
						"title": "General Contractor",
					},
					{
						"data": "attributes.city",
						"title": "City",
						"width": "20%"
					},
					{
						"data": "attributes.state",
						"title": "State",
						"width": "20%"
					},
					{
						"columnData": 'bidsDue',
						"data": {
							"_": function (row) {

								let dateTemp = new Date();
								if (row.attributes.rDueText === 'ASAP')
									return dateTemp.addDays(-10000);
								if (row.attributes.bidsDue == null)
									return dateTemp.addDays(-20000);

								return new Date(row.attributes.bidsDue);
							},
							"filter": "attributes.bidsDue",
							"display": function (row) {
								if (row.attributes.rDueText === 'ASAP')
									return row.attributes.rDueText;
								if (row.attributes.bidsDue == null)
									return "N/A";

								return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.bidsDue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
							}
						},
						"title": "Bids Due",
						"width": "150px"
					},
					{
						"data": "",
						"title": "",
						"orderable": false,
						"searchable": false,
						"width": "80px",
						"render": function () {
							return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-go-to-project"><span class="fal fa-arrow-alt-from-left"></span></button><button type="button" class="btn btn-danger btn-delete-project-invite ml-1" title="Delete Project Invite"><i class="fal fa-trash"></i></button></div>';
						}
					}
				]
			}
			else{
				let includeColumnsDefault = 'projectName,city,state,bidsDue';
				this.includeColumns = includeColumnsDefault;

				if ((this instanceof PJQ.views.projects.BiddingProjectsList) && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.BIDDING_PROJECTS_INCLUDE_COLUMNS))
					this.includeColumns = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.BIDDING_PROJECTS_INCLUDE_COLUMNS);

				columns = [
					{
						"columnData": 'isFavorite',
						"title": '',
						"render": function (data, type, row) {
							if (type === 'sort' || type === 'type')
								return row.attributes.isFavorite;
							return row.attributes.isFavorite ? '<button type="button" class="btn btn-transparent-light btn-favorite-project ml-2" title="Unmark Favorite" data-project-id="' + row.attributes.projectId + '"><i class="fas fa-star text-gold"></i></button>' : '<button type="button" class="btn btn-transparent-light btn-favorite-project ml-2" title="Mark Favorite" data-project-id="' + row.attributes.projectId + '"><i class="far fa-star text-muted"></i></button>';
						},
						"orderable": false,
						"searchable": false,
						"className": "text-center",
						"width": "60px",
						"visible": true
					}
				];

				_.each(this.includeColumns.split(','), _.bind(function(columnName) {
					switch (columnName) {
						case 'projectId':
							columns.push(
								{
									"data": "attributes.projectId",
									"title": "Project Id"
								}
							);
							break;
						case 'projectName':
							columns.push(
								{
									"data": "attributes.projectName",
									"title": "Name"
								}
							);
							break;
						case 'address1':
							columns.push(
								{
									"data": "attributes.address1",
									"title": "Address 1"
								}
							);
							break;
						case 'address2':
							columns.push(
								{
									"data": "attributes.address2",
									"title": "Address 2"
								}
							);
							break;
						case 'city':
							columns.push(
								{
									"data": "attributes.city",
									"title": "City",
									"width": (this.includeColumns === includeColumnsDefault) ? "20%" : null
								}
							);
							break;
						case 'state':
							columns.push({
								"data": "attributes.state",
								"title": "State",
								"width": (this.includeColumns === includeColumnsDefault) ? "20%" : null
							});
							break;
						case 'zip':
							columns.push({
								"data": "attributes.zip",
								"title": "Zip"
							});
							break;
						case 'country':
							columns.push({
								"data": "attributes.country",
								"title": "Country"
							});
							break;
						case 'created':
							columns.push({
								"columnData": "created",
								"data": {
									"_": function (row) {
										return new Date(row.attributes.created);
									},
									"filter": "attributes.created",
									"display": function (row) {
										return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.created), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
									}
								},
								"title": "Created"
							});
							break;
						case 'bidsDue':
							columns.push({
								"columnData": 'bidsDue',
								"data": {
									"_": function (row) {

										let dateTemp = new Date();
										if (row.attributes.rDueText === 'ASAP')
											return dateTemp.addDays(-10000);
										if (row.attributes.bidsDue == null)
											return dateTemp.addDays(-20000);


										return new Date(row.attributes.bidsDue);
									},
									"filter": "attributes.bidsDue",
									"display": function (row) {
										if (row.attributes.rDueText === 'ASAP')
											return row.attributes.rDueText;
										if (row.attributes.bidsDue == null)
											return "N/A";

										return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.bidsDue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
									}
								},
								"title": "Bids Due",
								"width": "150px"
							});
							break;
						case 'startDate':
							columns.push({
								"columnData": "startDate",
								"data": {
									"_": function (row) {
										return new Date(row.attributes.startDate);
									},
									"filter": "attributes.startDate",
									"display": function (row) {
										return row.attributes.startDate ? PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.startDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
									}
								},
								"title": "Start Date"
							});
							break;
						case 'endDate':
							columns.push({
								"columnData": "endDate",
								"data": {
									"_": function (row) {
										return new Date(row.attributes.endDate);
									},
									"filter": "attributes.endDate",
									"display": function (row) {
										return row.attributes.endDate ? PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.endDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
									}
								},
								"title": "End Date"
							});
							break;
						case 'userDisplayName':
							columns.push({
								"columnData": 'userDisplayName',
								"data": {
									"_": function (row) {
										return (row.attributes.user && row.attributes.user.displayName) ? row.attributes.user.displayName : '';
									}
								},
								"title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) : "Project Contact"
							});
							break;
						case 'user2DisplayName':
							columns.push({
								"columnData": 'user2DisplayName',
								"data": {
									"_": function (row) {
										return (row.attributes.user2 && row.attributes.user2.displayName) ? row.attributes.user2.displayName : '';
									}
								},
								"title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) : "Project Contact 2"
							});
							break;
						default:
							if (columnName.startsWith('fieldValue')) {
								// Project Custom Fields
								_.each(PJQ.app.session.customFields.project[(PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))].models, _.bind(function (customField) {
									if (columnName === 'fieldValue' + customField.get('fieldNumber'))
										columns.push({
											"columnData": 'fieldValue' + customField.get('fieldNumber'),
											"title": customField.get('fieldName'),
											"render": function (data, type, row) {
												let fieldValue = row.getCustomFieldValue(customField.get('id'));
												fieldValue = fieldValue ? fieldValue : '';
												switch (customField.get('fieldType')) {
													case PJQ.constants.customFields.fieldTypes.TEXT:
														if (fieldValue && type !== 'sort' && type !== 'type') {
															if (PJQ.helpers.urlHelpers.isURL(fieldValue))
																fieldValue = '<a target="_blank" href="' + fieldValue + '">' + fieldValue + '</a>';
														}
														break
													case PJQ.constants.customFields.fieldTypes.DATE:
														if (fieldValue) {
															if (type !== 'sort' && type !== 'type')
																fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
														}
														if (fieldValue === undefined)
															fieldValue = '';
														break;
													case PJQ.constants.customFields.fieldTypes.DATETIME:
														if (fieldValue) {
															if (type !== 'sort' && type !== 'type')
																fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_PROJECT_WALL) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.NEW_APP_PORTAL));
														}
														if (fieldValue === undefined)
															fieldValue = '';
														break;
													case PJQ.constants.customFields.fieldTypes.BOOL:
														if (fieldValue != null)
															fieldValue = fieldValue ? 'Yes' : 'No';
														else
															fieldValue = '';
														break;
													case PJQ.constants.customFields.fieldTypes.CHOICE:
														if (fieldValue) {
															let choices = [];

															// convert single choice value into array so that the logic below can work for both types.
															if (typeof fieldValue === 'number')
																fieldValue = [fieldValue];

															_.each(customField.choices.models, _.bind(function (choice) {
																if (_.find(fieldValue, function (value) {
																	return value === choice.get('id');
																}))
																	choices.push(choice.get('choiceName'));
															}, this));

															fieldValue = choices.join((', '));
														}
														break;
													case PJQ.constants.customFields.fieldTypes.MONEY:
														if (type === 'sort' || type === 'type') {
															if (fieldValue && fieldValue !== '$')
																fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
															else
																fieldValue = 0;

														}
														else {
															fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
														}
														break;
													case PJQ.constants.customFields.fieldTypes.INT:
														if (type !== 'sort' && type !== 'type' && fieldValue) {
															fieldValue = parseInt(fieldValue).toLocaleString();
														}
														break;
												}

												return fieldValue;
											}
										});

								}, this));
							}
							break;

					}
				}, this));

				columns.push({
						"data": "",
						"title": "",
						"orderable": false,
						"searchable": false,
						"width": (this instanceof PJQ.views.projects.BiddingProjectsList) ? "50px" : "80px",
						"render": _.bind(function () {
							let html = '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-go-to-project"><span class="fal fa-arrow-alt-from-left"></span></button>';

							if (!(this instanceof PJQ.views.projects.BiddingProjectsList))
								html += '<button type="button" class="btn btn-danger btn-delete-project-invite ml-1" title="Delete Project Invite"><i class="fal fa-trash"></i></button>';

							html += '</div>';
							return html;
						}, this)
				});
			}
			this.dataTable = new PJQ.views.projects.ProjectInviteListDataTable({
				el: this.$('.project-invites-list'),
				collection: this.collection,
				data: this.collection.models,
				language: this.options.language,
				contextMenuOptions: {
					actions: [
						{
							name: 'Go to Project',
							onClick: _.bind(function (row) {
								this.goToProject(row.data());
							}, this)
						},
						{
							name: 'Delete',
							iconClass: 'fal fa-trash',
							isDanger: true,
							onClick: _.bind(function (row) {
								this.deleteProjectInvite(row.data().id);
							}, this),
							isShown: _.bind(function() {
								return !(this instanceof PJQ.views.projects.BiddingProjectsList);
							}, this)
						}
					]
				},
				orderCookie: PJQ.constants.cookies.PROJECT_INVITES_ORDER_COOKIE,
				order: [[4, "desc"]],
				columns: columns,
				dom: '<"top"<"clear"><"project-list-buttons"><"project-list-buttons-right">p>rt<"bottom"p<"clear">>',
				onRowDoubleClick: _.bind(function (row) {
					this.goToProject(row.data());
				}, this),
				onGoToProject: _.bind(function (row) {
					this.goToProject(row.data());
				}, this),
				settings: new PJQ.models.projects.ProjectInvitesSettings()
			});
		}
	},
	deleteProjectInviteClicked: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
		this.deleteProjectInvite(row.data().id);
	},
	deleteProjectInvite: function (projectId) {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to permanently delete this project invite?  It will never appear in your invites list again after it is deleted.",
			onDelete: _.bind(function () {
				new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'projects'
						},
						{
							endpoint: 'invites',
							value: projectId
						}
					])
				}).delete().done(_.bind(function () {
					let project = this.collection.get(projectId),
						row = this.dataTable.getRow(project.cid);
					this.dataTable.removeRow(row);
					PJQ.notifications.notify.successNotify({
						message: 'Project Invite successfully deleted'
					});
				}, this));
			}, this)
		});
	},
	joinDirectory: function () {
		PJQ.app.session.joinDirectory(_.bind(function () {
			this.render();
		}, this));
	},
	favoriteProject: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
			project = row.data();
		this.favoriteProjectList([project.id], !project.get('isFavorite'));
	},
	favoriteProjectList: function (ids, isFavorite) {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'favorites'
			}
		], [
			{
				parameter: "projects",
				value: ids
			},
			{
				parameter: "isFavorite",
				value: isFavorite
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function () {
			_.each(ids, _.bind(function (id) {
				_.each(this.dataTable.options.collection.models, function (row) {
					if (row.attributes.projectId === id)
						row.attributes.isFavorite = isFavorite;
				}, this);

				let $favoriteButton = $('.btn-favorite-project[data-project-id="' + id + '"] i');
				if (isFavorite) {
					$favoriteButton.removeClass('far').addClass(('fas'));
					$favoriteButton.removeClass('text-muted').addClass(('text-gold'));
				}
				else {
					$favoriteButton.removeClass('fas').addClass(('far'));
					$favoriteButton.removeClass('text-gold').addClass(('text-muted'));
				}
			}, this));
		}, this)).fail(function () {
		});

	},
	goToProjectClicked: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
		this.goToProject(row.data());
	},
	goToProject: function (project) {
		PJQ.app.router.navigate('projects/' + project.id.toString(), {
			trigger: true
		});
	}
});

PJQ.views.projects.BiddingProjectsList = PJQ.views.projects.ProjectInvitesList.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTLIST, 'bidding-projects-list'),
		language: {
			zeroRecords: "There are no bidding projects available at this time"
		}
	},
	beforeFirstRender: function () {
		if (PJQ.app.session.contact != null && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.BIDDING_PROJECTS_REQUIRE_APPROVAL) && PJQ.app.session.contact.get('isApprovalRequired')) {
			this.collection = null;
			this.needsApproval = true;
		}
		else {
			if (this.collection == null) {
				this.collection = new PJQ.collections.projects.Projects([], {
					isBidding: true
				});
			}

			let callback = _.bind(function() {
				this.collection.fetch({
					success: _.bind(function () {
						this.render();
					}, this)
				});
			}, this);

			if (PJQ.app.session.get('portalId') !== 4) {
				PJQ.app.session.fetchProjectCustomFields((PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId')),
					_.bind(function () {
						callback();
					}, this));
			}
			else
				callback();
		}
	},
	afterRender: function () {
		if (this.collection != null) {
			PJQ.views.projects.ProjectInvitesList.prototype.afterRender.call(this, ...arguments);
		}
	},
	renderData: function () {
		return {
			collection: this.collection,
			needsApproval: this.needsApproval === true
		}
	},
	goToProject: function (project) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: project.get('accessKey')
				},
				{
					endpoint: 'follow'
				}
			])
		}).get().done(_.bind(function () {
			PJQ.app.router.navigate('projects/' + project.id.toString(), {
				trigger: true
			});
		}, this));
	}
});
